/** Converte Blob/File em base64 (sem prefixo data:). Rejeita em erro/abort (iOS NotReadableError). */
export function blobToBase64(blob) {
  return blobToDataUrl(blob).then((dataUrl) =>
    dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl
  );
}

/** Converte Blob/File em data URL completa (data:image/...;base64,...). */
export function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    if (!blob) {
      reject(new Error('Blob inválido'));
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.error) {
        reject(reader.error);
        return;
      }
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Falha ao converter blob para data URL'));
        return;
      }
      resolve(result);
    };
    reader.onerror = () => reject(reader.error || new Error('Falha ao ler arquivo'));
    reader.onabort = () => reject(new Error('Leitura de arquivo abortada'));
    reader.readAsDataURL(blob);
  });
}

/** Promisifica pdfmake getBlob — erros no callback sobem para o caller. */
export function pdfMakeGetBlob(pdfDocGenerator) {
  return new Promise((resolve, reject) => {
    try {
      pdfDocGenerator.getBlob(resolve);
    } catch (err) {
      reject(err);
    }
  });
}

/** Promisifica pdfmake getBase64. */
export function pdfMakeGetBase64(pdfDocGenerator) {
  return new Promise((resolve, reject) => {
    try {
      pdfDocGenerator.getBase64(resolve);
    } catch (err) {
      reject(err);
    }
  });
}

export function exibirPdfNoIframe({ blob, iframeId = 'pdfViewer' }) {
  const iframe = document.getElementById(iframeId);
  if (!iframe || !blob) return;

  const url = URL.createObjectURL(blob);
  iframe.src = url;
}

export function baixarBlobPdf({ blob, fileName }) {
  if (!blob || !fileName) return;

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
